import { isEmpty as iEmptyObject, isNotEmptyString } from '../util/object';
import { isNotEmpty as isNotEmptyArray } from '../util/array';

import { VALID_LOG_LEVELS } from '../features/debug/sentry/constants';

// https://docs.sentry.io/enriching-error-data/context/?platform=javascript
/**
 * @class Log An object containing Sentry logging metadata.
 * @param {error|string} message the information/error to log
 * @param {oneof(VALID_LOG_LEVELS)} level Log level for logging  message
 * @param {object} extra information to log with the event
 * @param {object} tags Key/value pairs which generate breakdowns charts and search filters
 * @param {array[*]} fingerprint data, that is hashed, to group events into a single issue
 */
export default class Log {
  _extra;
  _fingerprint;
  _level;
  _message;
  _metadata;
  _tags;

  constructor(
    message,
    level,
    extra,
    tags,
    fingerprint,
    allowDuplicates = false,
  ) {
    const metadata = {};

    if (isNotEmptyString(message)) {
      this._message = message;
    }

    if (VALID_LOG_LEVELS.has(level)) {
      this._level = level;
      metadata.level = level;
    }

    if (!iEmptyObject(extra)) {
      this._extra = extra;
      metadata.extra = extra;
    }

    if (!iEmptyObject(tags)) {
      this._tags = tags;
      metadata.tags = tags;
    }

    if (isNotEmptyArray(fingerprint)) {
      this._fingerprint = fingerprint;
      metadata.fingerprint = fingerprint;
    }

    if (allowDuplicates) {
      metadata.allowDuplicates = allowDuplicates;
    }

    this._metadata = metadata;
  }

  get extra() {
    return this._extra;
  }

  get fingerprint() {
    return this._fingerprint;
  }

  get level() {
    return this._level;
  }

  get message() {
    return this._message;
  }

  get metadata() {
    return this._metadata;
  }

  get tags() {
    return this._tags;
  }

  /**
   * Checks if object is an instance of Log
   *
   * @param inputObject
   * @returns {boolean}
   */
  static isLog(inputObject) {
    return inputObject instanceof Log;
  }
}
